import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkComponent } from '@softline/dynamic';
import { LocalStorageDataAccess } from '@softline/core';

@Component({
  selector: 'soft-department-settings',
  imports: [CommonModule, FieldOkComponent],
  templateUrl: './department-settings.component.html',
  styleUrl: './department-settings.component.scss',
})
export class DepartmentSettingsComponent implements OnInit {
  readonly value = signal<any | null>(null);
  readonly localStorage = inject(LocalStorageDataAccess);

  async ngOnInit(): Promise<void> {
    const value = await this.localStorage.get<string>({ key: 'abteilung' });

    if (!value) return;

    this.value.set(JSON.parse(value));
  }

  onValueChanged(value: any | null): void {
    this.localStorage.set({ key: 'abteilung' }, JSON.stringify(value));
    this.value.set(value);
  }
}
